export const tour = (state) => state.tour;
